<template>
    <div class="dashboard">
        <div class="content">
            <span class="mb10 deal-profit-filters">
                <span>
                    Период:
                </span>
                <span class="period">
                    <el-date-picker
                        v-model="daysRange"
                        type="daterange"
                        range-separator="по"
                        start-placeholder="дата"
                        end-placeholder="дата"
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                        @change="getRating"
                    />
                </span>
                <span>
                    Офис:
                </span>
                <span class="office">
                    <el-select
                        v-model="officeId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        @change="getRating"
                    >
                        <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </span>
                <span>
                    Монтажник:
                </span>
                <span class="installer position">
                    <el-select
                        v-model="installerEmployerId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        filterable
                        autocomplete="On"
                        @change="val => filterByEmployer(val, localReferences.employerPositions.installer)"
                    >
                        <el-option v-for="item in installersList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </span>
                <span>
                    Менеджер:
                </span>
                <span class="manager position">
                    <el-select
                        v-model="managerEmployerId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        autocomplete="On"
                        filterable
                        @change="val => filterByEmployer(val, localReferences.employerPositions.manager)"
                    >
                        <el-option v-for="item in managersList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </span>
                <span>
                    Замерщик:
                </span>
                <span class="measurer position">
                    <el-select
                        v-model="measurerEmployerId"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        placeholder=""
                        size="mini"
                        clearable
                        autocomplete="On"
                        filterable
                        @change="val => filterByEmployer(val, localReferences.employerPositions.measurer)"
                    >
                        <el-option v-for="item in measurersList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </span>
            </span>
            <el-row v-loading="loading">
                <el-col>
                    <div class="table deal-profit-table" v-if="dealsData.length">
                        <div class="table-header">
                            <div class="table-row">
                                <div class="table-cell bold">
                                    <el-tooltip popper-class="table-header-hint" content="Рейтинг" effect="light" placement="top">
                                        <span></span>
                                    </el-tooltip>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'header'"
                                    class="table-cell bold"
                                >
                                    <span>{{ column.title }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="table-body">
                            <div v-for="(deal, index) in dealsData" :key="index" class="table-row">
                                <div class="table-cell rating">
                                    {{ index + 1 }}
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'data'"
                                    :class="[column.cellClass, getShadowClass(deal, column.field), installersDebtClass(column.field, deal[column.field])]"
                                >
                                    <div>
                                        <template v-if="column.field === 'id'">
                                            <a :href="getDealLink(deal[column.field])" target="_blank" class="link">
                                                {{ deal[column.field] }}
                                            </a>
                                        </template>
                                        <template v-else-if="inFinanceFieldNames(column.field)">
                                            {{ formatFinance(deal[column.field]) }}
                                        </template>
                                        <template v-else>
                                            {{ deal[column.field] }}
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-row-empty"></div>
                        <div class="table-footer footer-deal-profit">
                            <div class="table-row">
                                <div class="table-cell relative hide-border">
                                    <div class="table-label-total-deal">
                                        ИТОГО:
                                    </div>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'total'"
                                    :class="[column.cellClass, 'table-cell']"
                                >
                                    <div>
                                        <template v-if="column.field === 'address'">
                                            Кол-во заказов: {{ totalData.count }}
                                        </template>
                                        <template v-else-if="inFinanceFieldNames(column.field)">
                                            {{ formatFinance(totalData[column.field]) }}
                                        </template>
                                        <template v-else>
                                            {{ totalData[column.field] ? totalData[column.field] : '' }}
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import employersRating from '@/mixins/employersRating';
import localReferences from '@/helpers/localReferences';
import { formatFinance } from '@/common/utilities';

export default {
    name: 'DealProfitGrid',
    mixins: [
        employersRating
    ],
    data() {
        return {
            installerEmployerId: '',
            measurerEmployerId: '',
            managerEmployerId: '',
            officeId: null,
            loading: false,
            columns: [
                {
                    field: 'id',
                    title: 'id',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'contract',
                    title: '№ Заказа',
                    cellClass: 'table-cell text-left cut-text'
                },
                {
                    field: 'address',
                    title: 'Адрес доставки',
                    cellClass: 'table-cell text-left cut-text address-width'
                },
                {
                    field: 'volume',
                    title: 'Объём',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'squareM2',
                    title: 'М2',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'budget',
                    title: 'Сумма заказа',
                    cellClass: 'table-cell text-right cut-text'
                },
                {
                    field: 'productionCost',
                    title: 'Сумма в производство',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'prepayment',
                    title: 'Предоплата',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'deliveryBalance',
                    title: 'Остаток по доставке',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'installerBalance',
                    title: 'Остаток по монтажу',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'installM2',
                    title: 'Монтаж 1М2',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'percentInstallWork',
                    title: '% монт работы',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'installersSalary',
                    title: 'Монтажникам',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'installersDebt',
                    title: 'Долг монтажников',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'isManagerConclusionId',
                    title: 'Заключил менеджер?',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'bonusPercent',
                    title: 'Бонус %',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'bonusByPositionManager',
                    title: 'Бонус менеджеру',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'bonusByPositionMeasurer',
                    title: 'Бонус замерщику',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'bonusMeasurer',
                    title: 'Сверх',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'otherExpensesSum',
                    title: 'Другие расходы, включая штрафы',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'discount',
                    title: 'Скидка',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'percent',
                    title: '%',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'bonus1Percent',
                    title: '1% за заключение',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'manager',
                    title: 'Менеджер',
                    cellClass: 'table-cell text-left cut-text'
                },
                {
                    field: 'managerSalary',
                    title: 'ЗП менеджеру',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'measurer',
                    title: 'Замерщик',
                    cellClass: 'table-cell text-left cut-text'
                },
                {
                    field: 'measurerSalary',
                    title: 'ЗП замерщику',
                    cellClass: 'table-cell text-right'
                },
                {
                    field: 'installers',
                    title: 'ФИО монтажников',
                    cellClass: 'table-cell text-left cut-text'
                },
                {
                    field: 'deliveryDate',
                    title: 'Дата доставки',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'installationDate',
                    title: 'Дата монтажа',
                    cellClass: 'table-cell text-left'
                },
                {
                    field: 'sum',
                    title: 'Итого',
                    cellClass: 'table-cell text-right cut-text'
                }
            ]
        };
    },
    computed: {
        officeList() {
            return this.$store.state.references.offices;
        },
        managersList() {
            return this.$store.state.references.employers.filter(employer => employer.position_id === localReferences.employerPositions.manager);
        },
        measurersList() {
            return this.$store.state.references.measurers;
        },
        installersList() {
            return this.$store.state.references.installers;
        },
        dealsData() {
            return this.$store.state.analytics.deals;
        },
        totalData() {
            return this.$store.state.analytics.dealsTotal;
        }
    },
    methods: {
        formatFinance,
        async getRating() {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/getDealProfitRating', {
                    startDay: this.daysRange[0],
                    endDay: this.daysRange[1],
                    officeId: this.officeId,
                    managerEmployerId: this.managerEmployerId,
                    measurerEmployerId: this.measurerEmployerId,
                    installerEmployerId: this.installerEmployerId
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        filterByEmployer(val, positionId) {
            this.installerEmployerId = '';
            this.measurerEmployerId = '';
            this.managerEmployerId = '';
            if (positionId === localReferences.employerPositions.manager) {
                this.managerEmployerId = val;
            }
            if (positionId === localReferences.employerPositions.measurer) {
                this.measurerEmployerId = val;
            }
            if (positionId === localReferences.employerPositions.installer) {
                this.installerEmployerId = val;
            }
            this.getRating();
        },
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        installersDebtClass(column, value) {
            if (column === 'installersDebt') {
                if (value === 0) {
                    return 'green-bg-color';
                }
                return 'red-bg-color';
            }
        },
        inFinanceFieldNames(columnName) {
            const financeFields = ['installM2', 'budget', 'productionCost', 'prepayment', 'deliveryBalance', 'installerBalance', 'installersSalary', 'installersDebt', 'otherExpensesSum', 'managerSalary', 'measurerSalary', 'bonus1Percent', 'bonusMeasurer', 'sum'];
            if (financeFields.indexOf(columnName) !== -1) {
                return true;
            }
            return false;
        }
    }
};
</script>
